<template>
  <div class="container commonDetail">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/Mine/MyRegister' }"
        >查重列表</el-breadcrumb-item
      >
      <el-breadcrumb-item>查重详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="commonWhiteBg" v-if="orderInfo">
      <div class="topSteps">
        <el-steps :active="orderInfo.step">
          <el-step title="支付">
            <div slot="description">
              {{
                orderInfo.status == "10" ? "等待支付" : paymentInfo.payTimeText
              }}
            </div>
            <a-icon v-if="orderInfo.status != '10'" slot="icon" type="check" />
            <a-icon v-else slot="icon" type="redo" />
          </el-step>
          <el-step title="等待查重结果">
            <template v-if="orderInfo.status == '11'">
              <div slot="description">审核预计需要一周时间</div>
              <a-icon slot="icon" type="exclamation" />
            </template>
            <template v-else-if="orderInfo.status == '12'">
              <div slot="description">审核中，请稍后</div>
              <a-icon slot="icon" type="redo" />
            </template>
            <template v-else>
              <div slot="description">2020.12.29 12:10:54</div>
              <a-icon slot="icon" type="check" />
            </template>
          </el-step>
        </el-steps>
        <div class="rightMain">
          <div>
            <span class="label"> 订单编号：</span>
            <span class="value"> {{ orderInfo.orderNo }} </span>
          </div>
          <div>
            <span class="label"> 支付方式：</span>
            <span class="value"> {{ orderInfo.orderAmount }}</span>
          </div>
          <div class="btnWrap" v-if="orderInfo.status == '10'">
            <el-button type="primary" size="mini" @click="onGoPay">立即支付</el-button>
          </div>
        </div>
      </div>

      <div class="commonTitle mt32">查重信息</div>
      <div class="MainStepsForm">
        <div class="formWrap">
          <el-form ref="form" label-width="250px">
            <el-form-item label="订单编号" prop="orderNo">
              {{ orderInfo.orderNo }}
            </el-form-item>
            <el-form-item label="支付方式" prop="paymodeText">
              {{ orderInfo.paymodeText }}
            </el-form-item>
            <el-form-item label="查重文件" prop="evidenceFile">
              <div class="nameRow">
                <span v-for="(file, index) in orderInfo.items" :key="index"
                  >{{ file.sourceName }} &nbsp;</span
                >
                <router-link
                  :to="{ path: '/ExistingEvidence/FileList', query: { orderNo: orderNo,bizType:'register' } }"
                >
                  查看存证文件
                </router-link>
              </div>
            </el-form-item>
            <!-- <el-form-item label="登记名称">
              {{ orderInfo.subject }}
            </el-form-item>
            <el-form-item label="作品创作类型" prop="worksType" v-if="orderInfo.worksType">
              {{ constants.worksType[orderInfo.worksType * 1-1].label }}
            </el-form-item>
            <div v-for="(item,index) in orderInfo.authors" :key="index">
              <el-form-item :label="'作者'+(index+1)" prop="name">
                <span style="margin-right: 20px;">{{item.name}}</span>
                <span v-if="item.signatureType == '1'">(本名: {{item.signatureName}})</span>
                <span v-if="item.signatureType == '2'">(别名: {{item.signatureName}})</span>
              </el-form-item>
            </div>
            <el-form-item
              label="权利权属"
              prop="ownership"
              class="ownershipRow"
              v-if="orderInfo.ownership"
            >
              {{ constants.ownership[orderInfo.ownership * 1-1].label }}
            </el-form-item>
            <el-form-item label="权益拥有情况" prop="rightHave">
              <multiple-select
                v-model="orderInfo.copyrights"
                :isResultView="true"
                :listOpt="constants.right"
              ></multiple-select>
            </el-form-item>
            <el-form-item label="权利取得方式" prop="obtainType" v-if="orderInfo.obtainType">
              {{ constants.obtainType[orderInfo.obtainType * 1-1].label }}
            </el-form-item>
            <el-form-item v-if="orderInfo.obtainType == '4'" label="其他权利获得方式说明" prop="obtainTypeDesc.text">
              <el-input
                  v-model="orderInfo.obtainTypeDesc.text"
                  :rows="5"
                  disabled
                  type="textarea"
                ></el-input>
            </el-form-item>
            <el-form-item label="权利获得方式证明材料" prop="ownershipPicture.additionalProp1">
              <el-upload class="Uploader2 fl" action="" :disabled="true">
                <img v-if="orderInfo.ownershipPicture.additionalProp1" :src="orderInfo.ownershipPicture.additionalProp1" class="avatar">
              </el-upload>
              <el-upload v-if="orderInfo.ownershipPicture.additionalProp2" class="Uploader2 fl" action="" :disabled="true">
                <img v-if="orderInfo.ownershipPicture.additionalProp2" :src="orderInfo.ownershipPicture.additionalProp2" class="avatar">
              </el-upload>
            </el-form-item>
            <el-form-item label="作品创作性质" prop="creationNature" v-if="orderInfo.creationNature">
              {{ constants.creationNature[orderInfo.creationNature * 1-1].label }}
            </el-form-item>
            <el-form-item v-if="orderInfo.creationNature == '7'" label="作品性质说明" prop="creationPropertyDesc.text">
              <el-input
                v-model="orderInfo.creationPropertyDesc.text"
                :rows="5"
                disabled
                type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item label="内容简介" prop="creationIntention.text">
              <el-input
                v-model="orderInfo.creationIntention.text"
                :rows="5"
                disabled
                type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item label="创作过程" prop="creationOriginality.text">
              <el-input
                v-model="orderInfo.creationOriginality.text"
                :rows="5"
                disabled
                type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item label="创作完成时间" prop="finishTime">
              {{ orderInfo.finishTimeText }}
            </el-form-item>
            <el-form-item label="创作完成地点" prop="adress">
              {{ orderInfo.completeLocation.province}}-{{ orderInfo.completeLocation.city}}
            </el-form-item>
            <el-form-item label="作品发表状态" prop="publishStatus">
              {{ constants.publishStatus[orderInfo.publishStatus * 1-1].label }}
            </el-form-item>
            <el-form-item v-if="orderInfo.publishStatus == 2" label="首次发表时间" prop="publishTime">
              {{ orderInfo.publishTimeText }}
            </el-form-item>
            <el-form-item v-if="orderInfo.publishStatus == 2" label="发表地点" prop="adress">
              {{ orderInfo.publishLocation.province}}-{{ orderInfo.publishLocation.city}}
            </el-form-item> -->

            <!-- <el-form-item label="权利权属" prop="ownership" class="ownershipRow">
              {{ constants.ownership[orderInfo.belong].label }}
            </el-form-item>
            <el-form-item label="作者" prop="author">
              <span v-for="(author,index) in orderInfo.authors" :key="index">{{obligees[author]}} &nbsp; </span>
            </el-form-item>
            <el-form-item label="著作权人" prop="right">
              <span v-for="(author,index) in orderInfo.obligee" :key="index">{{obligees[author]}} &nbsp; </span>
            </el-form-item>
            <el-form-item label="作品创作类型" prop="creationType">
              {{ constants.creationType[orderInfo.creationType].label }}
            </el-form-item>
            <el-form-item label="作品创作性质" prop="creationNature">
              {{ constants.creationNature[orderInfo.creationProperty].label }}
            </el-form-item>
            <el-form-item label="创作完成时间" prop="finishTime">
              {{ orderInfo.finishTimeText }}
            </el-form-item>
            <el-form-item label="创作完成地点" prop="adress">
              {{ orderInfo.completeLocation.province }} {{ orderInfo.completeLocation.city }}{{ orderInfo.completeLocation.area }}
            </el-form-item>
            <el-form-item label="作品发表状态" prop="publishStatus">
              {{ constants.publishStatus[orderInfo.publishStatus].label }}
            </el-form-item>
            <el-form-item label="权益拥有情况" prop="rightHave">
              <multiple-select
                v-model="orderInfo.copyrights"
                :isResultView="true"
                :listOpt="constants.right"
              ></multiple-select>
            </el-form-item>
            <el-form-item label="创作意图" prop="yitu">
              <el-input
                v-model="orderInfo.creationIntention.text"
                :rows="4"
                disabled
                placeholder="请输入创作意图"
                type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item label="作品独创性" prop="name" class="mt8">
              <el-input
                v-model="orderInfo.creationOriginality.text"
                :rows="4"
                disabled
                placeholder="请输入作品存证名称"
                type="textarea"
              ></el-input>
            </el-form-item> -->
          </el-form>
        </div>
      </div>
      
    </div>
        <pay-dialog ref="payDialog" @close="onSetPayDialogClose"></pay-dialog>
  </div>
</template>

<script>
import {
  queryRegisterOrder,
  queryPaymentOrderByOutBizNp,
  paymentRegisterOrder
} from "@/api/EvidenceService";
import { queryObligeeList } from "@/api/ObligeeService";
import constants from "@/utils/constants";
import PayDialog from "@/views/multipleService/components/PayDialog";
import multipleSelect from "../../../components/form/multipleSelect";
export default {
  name: "RegisterDetail",
  components: { multipleSelect,PayDialog },
  data() {
    return {
      constants,
      orderNo: this.$route.query.orderNo,
      orderInfo: null,
      paymentInfo: {},
      stepIdx: 0, // 0 带支付, 1处理中,3 完成
      obligees: {},
    };
  },
  created() {
    this.loadData();
  },
  methods: {
      getStep(status){
      let step=0;
      if(status=='10'){
        step=0;
      }else if(status*1<21){
        step=1;
      }else {
        step=2;
      }
      return step;
    },
    loadData() {
      queryRegisterOrder(this.orderNo).then(({ data }) => {
        this.orderInfo = data;
        console.log("orderInfo::::::::",data);
        // this.orderInfo.paymodeText = constants.paymode[this.orderInfo.paymode];
        // this.orderInfo.finishTimeText = this.dayjs(
        //   this.orderInfo.completeTime * 1000
        // ).format("YYYY-MM-DD HH:mm:ss ");
        //   this.orderInfo.step=this.getStep(this.orderInfo.status);

        // this.orderInfo.createTimeText = this.dayjs(
        //   this.orderInfo.createTime * 1000
        // ).format("YYYY-MM-DD HH:mm:ss ");
        // this.orderInfo.updateTimeText = this.dayjs(
        //   this.orderInfo.updateTime * 1000
        // ).format("YYYY-MM-DD HH:mm:ss ");
        // if(this.orderInfo.publishTime){
        //   this.orderInfo.publishTimeText = this.dayjs(
        //     this.orderInfo.publishTime * 1000
        //   ).format("YYYY-MM-DD HH:mm:ss ");
        // }

        // if (this.orderInfo.status != "10") {
        //   queryPaymentOrderByOutBizNp(this.orderNo, "2").then(({ data }) => {
        //     this.paymentInfo = data;
        //     this.paymentInfo.payTimeText = this.dayjs(
        //       this.paymentInfo.updateTime * 1000
        //     ).format("YYYY-MM-DD HH:mm:ss ");
        //   });
        // }
      });

      // queryObligeeList(1, 100).then(({ data }) => {
      //   let obligees={};
      //   for (let i = 0; i < data.list.length; i++) {
      //     const element = data.list[i];
      //       obligees[element.obligeeCode]=element.obligeeType=='0'?element.userName:element.companyName;
      //   }
      //   this.obligees = obligees;
      // });
    },
     onGoPay() {
      let that = this;
      paymentRegisterOrder(that.orderNo).then(({data})=>{
            that.$refs.payDialog.showDialog(data);
            that.isPayDialogVisible = true;
      })
    
    },
    onSetPayDialogClose(result) {
      console.log(result);
      if (result) {
        this.loadData();
      }
    },
  },
};
</script>

<style lang='scss' scoped>
@import "../../../assets/css/inputForm.scss";
.Uploader2, .Uploader3{
    font-size: 14px;
    width: 132px;
    height: 180px;
    text-align: center;
    background: #f9fafc;
    border-radius: 4px;
    border: 1px solid #c0ccda;
    position: relative;
    display: inline-block;
    margin-right: 20px;
}
.Uploader2 img, .Uploader3 img {
    width: 100%;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>
